module.exports = __webpack_public_path__ + "static/media/Point Solution Marketplace - GBR Network - 28-05-2025 N.72bea812.gif";